var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2103 0.000244141H0.510254C0.230254 0.000244141 0.0102539 0.220244 0.0102539 0.500244V17.5002C0.0102539 17.7802 0.230254 18.0002 0.510254 18.0002H15.5103C15.7903 18.0002 16.0103 17.7802 16.0103 17.5002V5.80024C16.0103 5.67024 15.9603 5.54024 15.8603 5.45024L10.5703 0.150244C10.4803 0.0602441 10.3503 0.000244141 10.2203 0.000244141H10.2103ZM10.0103 2.41024L12.6003 5.00024H10.0103V2.41024ZM14.0103 16.0002H2.01025V2.00024H8.01025V6.50024C8.01025 6.78024 8.23025 7.00024 8.51025 7.00024H14.0103V16.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/IconNote.a11936b543d6fb91d700a23ab80a3e7f.svg";
export { ForwardRef as ReactComponent };